import {
  getThemeMode,
  reportDarkPalette
} from "assets/jss/material-dashboard-react.jsx";

export const getDeviceDetailsPalette = isDark => {
  if (isDark) {
    return {
      primary: reportDarkPalette.accent,
      primaryDark: reportDarkPalette.accent,
      primarySoft: "rgba(128, 163, 255, 0.12)",
      panelStart: reportDarkPalette.elevated,
      panelEnd: reportDarkPalette.bg,
      border: reportDarkPalette.stroke,
      textMain: reportDarkPalette.text,
      textMuted: reportDarkPalette.textMuted
    };
  }
  return {
    primary: "#1d4ed8",
    primaryDark: "#1e3a8a",
    primarySoft: "#dbeafe",
    panelStart: "#f8fbff",
    panelEnd: "#eef5ff",
    border: "rgba(37, 99, 235, 0.2)",
    textMain: "#0f172a",
    textMuted: "#475569"
  };
};

export const isDarkUiTheme = theme => getThemeMode(theme) === "dark";

export const devicePanelGradient = isDark =>
  isDark
    ? `linear-gradient(180deg, ${reportDarkPalette.elevated} 0%, #1a1a1a 100%)`
    : "linear-gradient(180deg, rgba(255,255,255,0.98) 0%, #f8fbff 100%)";

export const deviceSurfaceColor = isDark =>
  isDark ? reportDarkPalette.elevated : "#ffffff";
